// ROUTER CONFIGURATION

import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Settings from "../views/Settings.vue";
import Error404 from "../views/Error404.vue";

Vue.use(VueRouter);

//all routes in the app
const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/*",
    name: "Error 404",
    component: Error404,
  },
];

//initialize new Router
const router = new VueRouter({
  routes,
});

export default router;
